<template>
    <div style="height: 100%;">
        <div style="width:100%;height:auto;">
            <IntroductionVue></IntroductionVue>
        </div>
        <div style="width:94%;height: 370px;margin:3%">
            <el-card style="width:70%;height: 370px;display:inline-block;margin-right: 1%;">
                <div slot="header" class="clearfix" style="display: inline-block;height: 100%;width: 10%;">
                    <span>Statistics</span>
                </div>
                <MultiBarchartVue></MultiBarchartVue>
            </el-card> 
            <el-card style="width:28%;height: 370px;display: inline-block; ">
                <div slot="header" class="clearfix">
                    <span>History</span>
                </div>
                <div style="height:auto;margin: 4%;font-size:16px;vertical-align: left:  !important;;">
                    <h3>Update History</h3>
                    December 2023, the original MDDOmics v1.0 database was released.
                    <h3>Current Version</h3>
                    MDDOmics V1.0
                </div>
            </el-card>
        </div>
       
    </div>
    </template>
    
    <script>
    import MultiBarchartVue from '../chart/MultiBarchart'
    import IntroductionVue from '../components/Introduction.vue'
    export default {
        data(){
            return{
                
            }
        },
        components:{
            MultiBarchartVue,
            IntroductionVue
        }
    }
    </script>
    
    
    
    <style>
    .el-card .el-card__header {
        background-color: rgb(228,146,0) ;
        color: white;
        font-size:20px;
        line-height: 40px;
        padding: 0%;
        height: 40px ;
    }
    .card-header{
        background-image:linear-gradient(to bottom right,  rgb(81,134,1),rgb(133, 165, 2));
        display:flex;
        align-items: center;
        justify-content: center; 
        color:white;
    }
    .horn{
        width: 100%;
        height: auto;
        position:relative;
        background: linear-gradient(rgb(135,201,36), rgb(235,181,99)) left top,
            linear-gradient(rgb(135,201,36), rgb(235,181,99)) left top,
            linear-gradient(rgb(135,201,36), rgb(235,181,99)) right top,
            linear-gradient(rgb(135,201,36), rgb(235,181,99)) right top,
            linear-gradient(rgb(135,201,36), rgb(235,181,99)) left bottom,
            linear-gradient(rgb(135,201,36), rgb(235,181,99)) left bottom,
            linear-gradient(rgb(135,201,36), rgb(235,181,99)) right bottom,
            linear-gradient(rgb(135,201,36), rgb(235,181,99)) right bottom;
        background-repeat: no-repeat;
        background-size: 5px 20px, 20px 5px;
    }
    </style>
    
    <style scoped>
    .card-header{
        height: 7%;
    }
    </style>